import React, { useRef } from 'react';
import { DialogContent } from '@reach/dialog';
import { useClickAway } from 'react-use';
import { styled } from 'styled-components';
import { useDialogDispatch } from './DialogContext';
import { Colors } from '../../../../play-core/styles/Colors';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { jsx as _jsx } from "react/jsx-runtime";
export const DialogContentWrapper = ({
  title,
  children,
  className
}) => {
  const dispatch = useDialogDispatch();
  const dialogRef = useRef(null);
  useClickAway(dialogRef, () => {
    setTimeout(() => dispatch({
      type: 'remove-dialog'
    }), 0);
  });
  return /*#__PURE__*/_jsx(StyledDialogContent, {
    ref: dialogRef,
    "aria-label": title,
    className: className,
    onKeyUp: event => {
      // Close the dialog with Escape key
      if (event.keyCode === 27) {
        dispatch({
          type: 'remove-dialog'
        });
      }
    },
    children: children
  });
};
const StyledDialogContent = styled(DialogContent).withConfig({
  displayName: "DialogContentWrapper__StyledDialogContent",
  componentId: "sc-5ots6j-0"
})(["", "{padding:20px 8px 8px 8px;}&[data-reach-dialog-content]{width:auto;padding:40px 24px 24px;background-color:", ";border-radius:4px;margin-left:40px;margin-right:40px;}"], Viewports.for('small'), Colors.GREY_3a3a3a);